export default __webpack_public_path__ + "static/media/sensotrend_connect_install_uploader1.8e61a2db.png";